import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core/services/web-storage';
import { ClienteAnaliseMercadoClienteListStorage } from './cliente-analise-mercado-cliente-list-storage';

/**
 * Service utilizado para armazenar os dados do filter da análise de mercado de cliente no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoClienteListStorageService {

    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem o storage do Session Storage do navegador */
    get(key: string): ClienteAnaliseMercadoClienteListStorage {
        const storage = this.sessionStorageService.getObject(key) as ClienteAnaliseMercadoClienteListStorage;
        if (!storage) {
            return new ClienteAnaliseMercadoClienteListStorage();
        }
        return storage as ClienteAnaliseMercadoClienteListStorage;
    }

    /** Seta o storage no Session Storage do navegador */
    set(key: string, storage: ClienteAnaliseMercadoClienteListStorage) {
        this.sessionStorageService.setObject(key, storage);
    }

    /** Remove o storage do Session Storage do navegador */
    remove(key: string) {
        this.sessionStorageService.remove(key);
    }
}
